import React, { useEffect, useState } from 'react'
import {
	CircularProgress, Grid, TextField, Typography, Chip, Accordion, AccordionSummary, AccordionDetails, Box,
} from '@mui/material'
import { ClassNameMap } from '@mui/styles'
import Autocomplete from '@mui/material/Autocomplete'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import 'react-calendar/dist/Calendar.css'
import { checkCondition } from '../common/condition-check'
import Helper from '../../../../utils/helper'
import { PatientService } from '../../../../services/patient.service'
import EmptyCardComponent from '../common/empty-card.component';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { useThemeMode } from '../../../../contexts/ThemeContext';

interface IProps {
	outer: any
	propagation: any
	existingMed: any
	classes: ClassNameMap
}

const AutoCompleteMedicine: React.FC<IProps> = ({ classes, existingMed, propagation, outer }) => {
	const { mode } = useThemeMode()
	const isDarkMode = mode === 'dark'
	const [oneMedicine, setOneMedicine] = useState(existingMed)
	const patientService = new PatientService()
	const [medicineOpen, setMedicineOpen] = useState(false)
	const [medicine, setMedicine] = useState([] as any)
	const [ingredient, setIngredient] = useState(true)
	const [aa_formulation, setAaFormulation] = useState(true)
	const [medication_class, setmedicationClass] = useState(true)
	const [query, setQuery] = useState("");
	const [loading, setLoading] = useState(false)

	useEffect(() => {
		let active = true
		if (active && query.length >= 2) {
			setLoading(true)
			patientService.getRxNorms(query, propagation, aa_formulation, medication_class, ingredient).then((response: any) => {
				setMedicine(response.data)
				setLoading(false)
			}).catch(() => setLoading(false))
		}
		return () => {
			active = false
		}
	}, [query])

	const debounce = (func: any, delay: any) => {
		let debounceTimer: any
		return function () {
			const context = func
			const args = arguments
			clearTimeout(debounceTimer)
			debounceTimer = setTimeout(() => func.apply(context, args), delay)
		}
	}

	const handleChipClick = (type: string) => {
		if (type === 'ingredient') setIngredient(!ingredient)
		if (type === 'medication') setAaFormulation(!aa_formulation)
		if (type === 'class') setmedicationClass(!medication_class)
	}

	const selectedBg = isDarkMode ? '#4CAF50' : '#3E3D3B'
	const selectedText = '#FFFFFF'
	const unselectedText = isDarkMode ? '#B0B0B0' : '#666666'

	const chipSx = (selected: boolean) => ({
		margin: '0.3rem',
		textTransform: 'none',
		height: '25px',
		fontWeight: 500,
		backgroundColor: `${selected ? selectedBg : 'transparent'} !important`,
		color: `${selected ? selectedText : unselectedText} !important`,
		border: selected ? 'none' : `1px solid ${isDarkMode ? '#555' : '#ccc'}`,
		'&:hover': {
			backgroundColor: `${selected ? selectedBg : 'transparent'} !important`,
		},
		'&:focus': {
			backgroundColor: `${selected ? selectedBg : 'transparent'} !important`,
		},
	})

	return <>
		<Grid container className={classes.medicationsBoxDisplay}>
			<Grid item className={classes.fullWidth}>
				<Chip sx={chipSx(aa_formulation)} label="medication" onClick={() => handleChipClick('medication')} />
				<Chip sx={chipSx(medication_class)} label="class" onClick={() => handleChipClick('class')} />
				<Chip sx={chipSx(ingredient)} label="ingredient" onClick={() => handleChipClick('ingredient')} />
			</Grid>
			<Grid item>
				<Autocomplete
					id="combo-medicine"
					open={medicineOpen}
					onOpen={() => {
						setMedicineOpen(true)
						setMedicine([])
						setQuery('')
					}}
					onClose={() => {
						setMedicineOpen(false)
						setMedicine([])
						setQuery('')
					}}
					options={medicine as any}
					filterOptions={(x) => x}
					getOptionLabel={(option: any) => option?.type !== '' ? Helper.getRXnorm(option?.name, option?.type) : option.name}
					className={classes.autoCompleteDropDowns}
					loading={loading}
					// value={oneMedicine}
					onChange={(_event, newValue) => {
						setOneMedicine(newValue);
						outer(newValue)
					}}
					renderInput={(params) => (
						<TextField
							{...params}
							onChange={debounce((e: any) => {
								setQuery(e.target.value)
								if (e.target.value === '') {
									setMedicine([])
								}
							}, 2000)}
							variant="standard"
							label="Medicine Selection"
							InputLabelProps={{ sx: { fontSize: '0.75rem' } }}
							InputProps={{
								...params.InputProps,
								endAdornment: (
									<React.Fragment>
										{checkCondition(
											loading,
											<CircularProgress color="inherit" size={20} />, null
										)}
										{params.InputProps.endAdornment}
									</React.Fragment>
								),
							}}
						/>
					)}
				/>
			</Grid>
		</Grid>
	</>
}

export default AutoCompleteMedicine
